import React from 'react'
import { NavLink } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux'
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import Notifications from './Notifications';
import Profile from './Profile';
import Hidden from '@material-ui/core/Hidden';


const styles = {
  avatar: {
    margin: 10,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  link: {
    textDecoration: 'none',
    color: "white"
  }

};

const SignedInLinks = (props) => {
  const { classes, navigations } = props;
  return (
    <div>
      <Hidden only={['xs', 'sm']}>
        <NavLink to='/' style={styles.link} ><Button color="inherit" >Dashboard </Button></NavLink>
        <NavLink to='/' style={styles.link} ></NavLink>
        {
          navigations && navigations.length ? navigations.map((navigation) => {
            return <NavLink to={navigation.path} key={navigation.path} style={styles.link}>
              <Button color="inherit" >{navigation.title}</Button>
            </NavLink>
          })
            : null
        }
      </Hidden>
      <NavLink to='/' style={styles.link} ><Button color="inherit" onClick={props.signOut}>Log Out </Button></NavLink>
      <Notifications />
      <Profile/>
      {/* <Button color="inherit"><Avatar className={classes.avatar}><NavLink to='/' style={styles.link}>{props.profile.initials}</NavLink> </Avatar> </Button> */}
    </div>
  )
}

const mapDispatchToProps = (disptach) => {
  return {
    signOut: () => disptach(signOut())
  }
}

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)
  (SignedInLinks)